import { useState } from 'react';

export const useDrag = () => {
    const [isDragging, setIsDragging] = useState(false);

    const handlerDragEnter = (e) => {
        e?.preventDefault();
        setIsDragging(true);
    };
    const handleDragLeave = (e) => {
        e?.preventDefault();
        handleResetDrag();
    };

    const handleResetDrag = () => {
        setIsDragging(false);
    };

    return { handleDragLeave, handlerDragEnter, isDragging, handleResetDrag };
};
